const INJECTED_USER_SCRIPT_PATTERN = /\buser-script:/


// A rejected non-Error value keeps its stack only as a serialized string, so the
// frame-based checks never see it. Safari labels scripts injected by extensions
// and userscript managers (via WKUserScript) as `user-script` rather than an
// off-origin URL. A serialized stack that names those and never our origin came
// from injected code, not ours.
//
export default function isInjectedUserScriptError(event) {
  const serializedStack = event?.extra?.__serialized__?.stack || ''

  return INJECTED_USER_SCRIPT_PATTERN.test(serializedStack)
    && !serializedStack.includes(`${ window.location.origin }/`)
}
